@if(myWallets.length || otherWallets.length) {
    @if(myWallets.length) {
        @if(modalType === addressBookWalletViewType.ADDRESS_BOOK) {
			<p class="wallet-type">{{ "my_wallets" | translate }}</p>
		} @else {
			<p class="text-left">{{ "your_wallets" | translate }}</p>
		}
        @for (wallet of myWallets; track wallet; let last = $last) {
            <wallet-item (click)="viewWallet(wallet)" [wallet]="wallet" [hideBottomBorder]="last"></wallet-item>
         }
    }

    @if(otherWallets.length) {
		@if(modalType === addressBookWalletViewType.ADDRESS_BOOK) {
			<p class="wallet-type">{{ "other_wallets" | translate }}</p>
		} @else {
			<p class="text-left pt-15">{{ "saved_wallets" | translate }}</p>
		}
        @for (wallet of otherWallets; track wallet; let last = $last) {
            <wallet-item (click)="editWallet(wallet)" [wallet]="wallet" [hideBottomBorder]="last"></wallet-item >
        }
    }
} @else {
    @if (!queryText) {
		<div class="no-results">
			<div class="mt-20 mb-20">
				<img [src]="'/assets/images/wallet-round.svg'"
					[alt]="'wallet-image' | translate" />
			</div>
			<h4>{{ "address_book_no_wallets_saved" | translate }}</h4>
			<p class="description">{{"address_book_no_wallets_description" | translate}}</p>
			@if(modalType !== addressBookWalletViewType.WITHDRAW) {
				<a class="btn btn-primary"
					(click)="addNewWallet()"
					>
					<span>{{ "add_wallet" | translate }}</span>
				</a>
			}
    	</div>
	} @else {
		<div class="no-results">
			<div class="mt-20 mb-20">
				<img [src]="'/assets/images/search-round.svg'"
					 [alt]="'search-image' | translate" />
			</div>
			<h4>{{ "address_book_no_wallets_found_title" | translate: [queryText] }}</h4>
			<p class="description">{{"address_book_no_wallets_found_description" | translate}}</p>
		</div>
	}
}
